import { useMemo } from 'react';
import ResponsiveTable from '../../../../../shared/components/ResponsiveTable';
import {
  HeaderPropSortCallback,
  SortedColumn,
} from '../../../../../shared/components/ResponsiveTable/models';
import { InternalAdminModel, InternalAdminActions } from '../models';
import NameCell from '../../AdminsTab/AdminsList/TableCells/NameCell';
import RoleCell from '../../AdminsTab/AdminsList/TableCells/RoleCell';
import styles from './internalAdminList.module.scss';
import RegisteredCell from './TableCells/RegisteredCell';
import ActionsCell from './TableCells/ActionsCell';
import LastLoggedIn from './TableCells/LastLoggedIn';
import InvitedBy from '../../AdminsTab/AdminsList/TableCells/InvitedByCell';

interface AdminsListProps {
  list: InternalAdminModel[];
  isLoading: boolean;
  handleSort: HeaderPropSortCallback;
  actions: InternalAdminActions;
  isDeveloper: boolean;
}

// todo - implement sorting
const getColumns = (
  actions: InternalAdminActions,
  isDeveloper: boolean,
): SortedColumn[] => [
  {
    name: 'name',
    title: 'Name',
    cell: (cntx) => <NameCell row={cntx.row} />,
    width: 30,
    sortingEnabled: true,
  },
  {
    name: 'role',
    title: 'Role',
    cell: (cntx) => <RoleCell row={cntx.row} />,
    width: 15,
    sortingEnabled: true,
  },
  {
    name: 'dateRegistered',
    title: 'Registration',
    cell: (cntx) => <RegisteredCell row={cntx.row} />,
    width: 15,
    sortingEnabled: true,
  },
  {
    name: 'lastLoggedIn',
    title: 'Last Accessed',
    cell: (cntx) => <LastLoggedIn row={cntx.row} />,
    width: 15,
    sortingEnabled: true,
  },
  {
    name: 'invitedByPersonName',
    title: 'Invited By',
    cell: (cntx) => <InvitedBy row={cntx.row} />,
    width: 15,
    sortingEnabled: true,
  },
  {
    name: 'actions',
    title: '',
    cell: (cntx) => (
      <ActionsCell row={cntx.row} actions={actions} isDeveloper={isDeveloper} />
    ),
    width: 1,
  },
];

export default function InternalAdminList({
  list = [],
  isLoading,
  handleSort,
  actions,
  isDeveloper = false,
}: AdminsListProps) {
  const columns = useMemo(() => getColumns(actions, isDeveloper), [actions]);
  return (
    <div className={`${styles.adminsTableContainer} overflow-auto`}>
      {!isLoading && (
        <ResponsiveTable
          data={list}
          onSort={handleSort}
          columns={columns}
          className={`overflow-auto ${styles.tableAdmins}`}
        />
      )}
      {isLoading && <p className="py-2">Loading...</p>}
    </div>
  );
}
